import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  onCatalogList,
  onProductDelete,
  onProducts,
} from "../../redux/homeAction";
import CustomPagination from "../CustomPagination";
import FullScreenLoader from "../Common/FullScreenLoader";
import { useSearchParams } from "react-router-dom";

const CatalogList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const [status, setStatus] = useState(
    searchParams.get("status") || "pending_verification",
  );

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");

  const handleStatusChange = (value) => {
    setStatus(value);

    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set("status", value);
      return params;
    });
  };

  const getOnCatalogList = useSelector((state) => state.home.getOnCatalogList);

  useEffect(() => {
    dispatch(onCatalogList(page + 1, limit, status, setLoading));
  }, [page, status, dispatch]);

  return (
    <>
      <div className="p-4">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 mb-4">
          <h2 className="text-xl font-semibold">📦 Catalog Products</h2>

          <div className="flex items-center gap-3">
            {/* STATUS FILTER */}
            <div className="relative">
              <select
                value={status}
                onChange={(e) => handleStatusChange(e.target.value)}
                className="appearance-none bg-white border border-gray-200
             text-gray-700 px-4 py-2 pr-10 rounded-xl
             shadow-sm focus:outline-none focus:ring-2
             focus:ring-blue-500 hover:border-gray-300
             transition-all cursor-pointer"
              >
                <option value="pending">Pending</option>
                <option value="draft">Draft</option>
                <option value="pending_verification">
                  Pending Verification
                </option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>

              {/* dropdown icon */}
              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                ▼
              </div>
            </div>

            {/* ADD BUTTON */}
            <Link to="/add-single-catalog">
              <button
                className="bg-gradient-to-r from-blue-600 to-blue-700
                         text-white px-4 py-2 rounded-xl
                         shadow-md hover:shadow-lg hover:scale-[1.02]
                         transition-all duration-200"
              >
                + Add Catalog
              </button>
            </Link>
          </div>
        </div>

        <p className="mb-3 text-gray-600">
          Total Products: {getOnCatalogList?.count || 0}
        </p>

        {/* Desktop Table */}
        <div className="overflow-x-auto bg-white rounded-xl shadow">
          <table className="w-full text-sm">
            <thead className="bg-gray-900 text-white">
              <tr>
                <th className="p-3">S.no.</th>
                <th>Catalog Image</th>
                <th>Category</th>
                <th>Created Date</th>
                <th>Products</th>
                <th>QC Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {getOnCatalogList?.data?.map((p, i) => (
                <tr key={i} className="border-b hover:bg-gray-50">
                  <td className="p-3">{page * limit + i + 1}</td>

                  <td className="p-3">
                    <div className="flex items-center gap-3">
                      {/* IMAGE WRAPPER */}
                      <div className="relative group">
                        {/* glow border effect */}
                        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-gray-200 to-gray-300 blur-sm opacity-40 group-hover:opacity-60 transition" />

                        {/* image */}
                        <img
                          src={p?.images?.[0] || p?.image || "/placeholder.png"}
                          className="relative w-14 h-14 rounded-xl object-cover object-top border border-gray-200 shadow-sm"
                        />

                        {/* count badge (pixel styled like screenshot) */}
                        <div className="absolute -bottom-1 -right-1">
                          <div
                            className="flex items-center justify-center min-w-[18px] h-[18px] px-[5px]
                        bg-black text-white text-[10px] font-medium rounded-md
                        shadow-md border border-white"
                          >
                            {p?.productCount}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>

                  <td>{p?.category?.name}</td>
                  <td>{new Date(p.createdAt).toLocaleDateString()}</td>
                  <td>{p.productCount}</td>
                  <td>{p.status}</td>

                  <td className="space-x-2">
                    <button
                      onClick={() => navigate(`/catalogs-view/${p._id}`)}
                      className="px-2 py-1 text-xs bg-blue-500 text-white rounded"
                    >
                      View
                    </button>

                    <button
                      onClick={() => navigate(`/catalog/edit/${p._id}`)}
                      className="px-2 py-1 text-xs bg-yellow-500 text-white rounded"
                    >
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}

        {/* Pagination */}
        {getOnCatalogList?.totalPages > 1 && (
          <div className="mt-4">
            <CustomPagination
              page={page}
              totalPages={getOnCatalogList?.totalPages}
              onPageChange={(selected) => setPage(selected.selected)}
            />
          </div>
        )}
      </div>
      {loading && <FullScreenLoader />}
    </>
  );
};

export default CatalogList;
